import classnames from 'classnames';
import React from 'react';
import CheckIcon from 'v2/icons/CheckIcon';
import newBottomRightBlueDarkBgImage from 'v2/images/newBottomRightBlueDarkBgImage.svg';
import styles from './signUpSubscription.module.scss';

interface SubscriptionUpsellEnterpriseItemsProps {
  listItems: React.ReactElement[];
}

const TALK_TO_SALES =
  'https://landing.nomad-data.com/letstalk-enterprise-data-discovery';

const SubscriptionUpsellEnterpriseItems = ({
  listItems,
}: SubscriptionUpsellEnterpriseItemsProps) => {
  return (
    <>
      <img
        className={styles.newBottomRightBlueDarkBgImage}
        src={newBottomRightBlueDarkBgImage}
        alt="newBottomRightBlueDarkBgImage"
      ></img>
      <div className="z-index-1">
        <h1 className="mt-3">
          Maximize your
          <br />
          organization&apos;s potential.
        </h1>
        <ul className={classnames(styles.listContainer, 'mt-5 pl-3')}>
          {listItems.map((item, index) => (
            <li key={index} className="mb-4">
              <CheckIcon size={16} className="mr-4" />
              <div className={styles.text}>{item}</div>
            </li>
          ))}
        </ul>
        <div>
          <a
            href={TALK_TO_SALES}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary d-inline-block"
          >
            Talk to Sales
          </a>
        </div>
      </div>
    </>
  );
};

export default SubscriptionUpsellEnterpriseItems;
